import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';

import {Router, RouterModule} from '@angular/router';
import {MaterialModule} from '../../../material.module';
import {ConnectProviderDef, ConnectProvidersService} from '../../../services/connect/connect-providers.service';
import {EnvironmentService} from '../../../services/environment.service';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs';

@Component({
  selector: 'app-connect-settings',
  standalone: true,
    imports: [RouterModule, MaterialModule],
  templateUrl: './connect-settings.component.html',
  styleUrls: ['../connect-shared.scss', './connect-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'connect-theme'},
})
export class ConnectSettingsComponent implements OnInit {
  private readonly providersService = inject(ConnectProvidersService);
  private readonly environmentService = inject(EnvironmentService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly router = inject(Router);

  providers: ConnectProviderDef[] = [];
  loadingProviders = false;
  error: string | null = null;

    get authApiUrl(): string {
        return this.environmentService.authBaseServerUrl;
  }

  ngOnInit(): void {
    this.loadProviders();
  }

  refreshProviders(): void {
    this.loadProviders(true);
  }

  createProvider(): void {
    this.router.navigate(['/connect/settings/providers/new']);
  }

  openProvider(provider: ConnectProviderDef): void {
    this.router.navigate(['/connect/settings/providers', provider.id]);
  }

  private loadProviders(force = false): void {
    if (this.loadingProviders && !force) {
      return;
    }
    this.loadingProviders = true;
    this.providersService.fetchCatalog().pipe(
      catchError(err => {
        console.error('Failed to load providers', err);
        this.error = 'Could not load provider catalog yet.';
        this.providers = [];
        this.cdr.markForCheck();
        return of({version: 'v1', providers: []} as const);
      }),
      finalize(() => {
        this.loadingProviders = false;
        this.cdr.markForCheck();
      })
    ).subscribe(catalog => {
      this.providers = [...(catalog.providers || [])];
      this.cdr.markForCheck();
    });
  }
}
